module.exports = __webpack_public_path__ + "static/Sourcepoint-764efe8ac57207773e33d90eb0fb7015.jpg";